<div class="user-mapping-card">
  <div class="card-title">User mapping</div>
  <div class="card-content">
    <form class="form" [formGroup]="form">
      <onehub-ui-form-field>
        <span>Target email:</span>
        <onehub-ui-input-text
          [formControl]="form.controls.targetEmployee"
          [placeholder]="'email'"
        >
        </onehub-ui-input-text>
      </onehub-ui-form-field>

      <div class="button-group">
        <onehub-ui-button
          [variant]="ButtonVariant.Reject"
          [type]="ButtonType.Button"
          [disabled]="!form.valid"
          (action)="onDelete()">
          Delete
        </onehub-ui-button>

        <onehub-ui-button [variant]="ButtonVariant.Approve"
                          [type]="ButtonType.Button"
                          [disabled]="!form.valid"
                          (action)="onSubmit()">
          Submit
        </onehub-ui-button>
      </div>
    </form>
  </div>
</div>
